import { useState } from 'react'
import { deleteRequest } from '../../../shared/api/requests.api'
import { apiErrorText } from '../../../shared/api/errorText'
import { toast } from '../../../shared/ui/toastStore'
import { confirmRequestDeletion } from '../utils/confirmRequestDeletion'
import type { Request } from '../../../shared/api/types'

export function RequestsDeleteButton({ req, onDeleted }: { req: Request; onDeleted: () => void }) {
  const [deleting, setDeleting] = useState(false)

  const handleClick = async () => {
    // Confirm с составом заявки («позиций N, квот M, КП K») — удаление мягкое,
    // заявка уходит в корзину на 30 дней (кнопка «Корзина» на странице заявок).
    if (!(await confirmRequestDeletion(req.id, req.client?.name))) return
    setDeleting(true)
    try {
      await deleteRequest(req.id)
      onDeleted()
    } catch (e) {
      // Сервер отказывает, например, если по заявке оформлен заказ (409).
      toast.error(apiErrorText(e, 'Не удалось удалить заявку'))
    } finally {
      setDeleting(false)
    }
  }

  return (
    <button
      onClick={(e) => {
        e.stopPropagation()
        void handleClick()
      }}
      disabled={deleting}
      className="text-gray-300 hover:text-red-500 transition-colors disabled:opacity-40"
      title="Удалить заявку (в корзину)"
    >
      🗑
    </button>
  )
}
